import React, { memo } from "react";
import useStyles from "./styles";
import PromotionItem from "../PromotionItem";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const PromotionOrderDetail = memo(props => {
	const classes = useStyles();
	const { giftByCampaign } = props;

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.headerPromotion }}>
				<Grid classes={{ root: classes.titlePromotion }}>
					<img src={Images.icBgGift} alt={"icBgGift"} />
					<Grid classes={{ root: classes.threeDot }}>
						{giftByCampaign?.campaignName}
					</Grid>
				</Grid>
			</Grid>
			{giftByCampaign.giftByPromotions.map((giftByPromotion, index) => (
				<PromotionItem key={index} giftByPromotion={giftByPromotion} />
			))}
		</Grid>
	);
});

export default PromotionOrderDetail;
